module.exports = __webpack_public_path__ + "img/avatar.cc4a52ba.png";